import { leagueFetch } from '@leagueplatform/league-fetch';
import { MASONRY_ENDPOINTS } from 'common/constants';

export const timeZone =
  typeof Intl !== 'undefined'
    ? Intl.DateTimeFormat().resolvedOptions().timeZone
    : 'America/Edmonton';

export const fetchWithMasonryEndpoint = async (
  apiEndpoint: string,
  additionalHeaders: Record<string, string> = {},
) => {
  const headers = {
    'X-League-Client-Version': MASONRY_ENDPOINTS.MASONRY_CLIENT_VERSION,
    'X-League-Client-Platform': MASONRY_ENDPOINTS.MASONRY_CLIENT_PLATFORM,
    'X-League-Client-View-Size': MASONRY_ENDPOINTS.MASONRY_CLIENT_SIZE,
    'X-League-Client-Time-Zone': timeZone,
    ...additionalHeaders,
  };

  const response = await leagueFetch(apiEndpoint, { headers });

  if (!response.ok) {
    throw new Error(
      `Failed fetching data from ${apiEndpoint}: ${await response.text()}`,
    );
  }

  return response;
};
